<div class="btn-group" role="group">
    @for (pill of pills(); track pill.value) {
        <input
            type="radio"
            class="btn-check"
            autocomplete="off"
            [name]="groupName()"
            [id]="pill.id"
            [checked]="selected() === pill.value"
            [disabled]="disabled()"
            (change)="select(pill.value)" />
        <label [class]="labelClass" [for]="pill.id" [attr.title]="pill.title">
            @if (pill.iconClass !== null) {
                <i [class]="pill.iconClass"></i>
            }
            @if (pill.text !== null) {
                <span>{{ pill.text }}</span>
            }
        </label>
    }
</div>
